import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import { Link } from 'react-router-dom';

export default function MentionsLegales() {
  return (
    <>
      <SEOHead
        title="Mentions légales | DFPRO Lyon"
        description="Mentions légales de DFPRO Lyon, entreprise de dépannage et réparation de menuiseries à Lyon. SAS DF PRO, SIREN 984 775 262, TVA FR96 984 775 262."
        canonicalUrl="https://depanfenetres-lyon.fr/mentions-legales/"
      />
      <Header />

      <main className="pt-20 pb-16">
        <section className="w-full bg-background-100 py-12 md:py-16">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-xs text-secondary-400 mb-6 flex-wrap">
              <Link to="/" className="hover:text-primary-500 transition-colors">Accueil</Link>
              <i className="ri-arrow-right-s-line w-3 h-3 flex items-center justify-center"></i>
              <span className="text-secondary-500">Mentions légales</span>
            </nav>
            <h1 className="font-heading font-bold text-2xl md:text-4xl text-foreground-800">Mentions légales</h1>
          </div>
        </section>

        <section className="w-full bg-background-50 py-10 md:py-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <div className="space-y-8 text-sm text-secondary-500 leading-relaxed">
              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">Éditeur du site</h2>
                <p>Le site <strong>depanfenetres-lyon.fr</strong> est édité par la société :</p>
                <ul className="mt-2 space-y-1 list-none">
                  <li><strong>Raison sociale :</strong> DF PRO</li>
                  <li><strong>Forme juridique :</strong> SAS (Société par Actions Simplifiée)</li>
                  <li><strong>Siège social :</strong> 100 route de Nîmes, 30132 Caissargues, France</li>
                  <li><strong>SIREN :</strong> 984 775 262</li>
                  <li><strong>SIRET :</strong> 984 775 262 00020</li>
                  <li><strong>Code APE :</strong> 43.32A (Travaux de menuiserie bois et PVC)</li>
                  <li><strong>TVA intracommunautaire :</strong> FR96 984 775 262</li>
                  <li><strong>Directeur de la publication :</strong> Le Président de DF PRO</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">Contact</h2>
                <ul className="space-y-1 list-none">
                  <li><strong>Téléphone :</strong> <a href="tel:+33980803684" className="text-primary-500 hover:text-primary-600">09 80 80 36 84</a></li>
                  <li><strong>Email :</strong> <a href="mailto:lyon@dfpro.fr" className="text-primary-500 hover:text-primary-600">lyon@dfpro.fr</a></li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">Hébergement</h2>
                <p>Le site est hébergé par :</p>
                <ul className="mt-2 space-y-1 list-none">
                  <li><strong>Hébergeur :</strong> Infomaniak Network SA</li>
                  <li><strong>Adresse :</strong> 25 rue Eugène-Marziano, 1227 Genève, Suisse</li>
                </ul>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">Propriété intellectuelle</h2>
                <p>
                  L'ensemble du contenu de ce site (textes, images, graphismes, logo, icônes) est la propriété exclusive de DF PRO, à l'exception des marques et logos appartenant à leurs propriétaires respectifs. Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle, de ces éléments est strictement interdite sans l'accord écrit préalable de DF PRO.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">Marques tierces</h2>
                <p>
                  Somfy, Bubendorff, Velux, Profalux, Nice, Franciaflex, Simu, Faver et toute autre marque citée sur ce site sont des marques déposées par leurs propriétaires respectifs. DFPRO Lyon (DF PRO) n'est affiliée, sponsorisée ou approuvée par aucune de ces marques et intervient sur ces équipements en tant que réparateur indépendant.
                </p>
              </div>

              <div>
                <h2 className="font-heading font-semibold text-lg text-foreground-800 mb-3">Limitation de responsabilité</h2>
                <p>
                  DF PRO s'efforce de fournir des informations aussi précises que possible sur ce site. Toutefois, elle ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition. En conséquence, DF PRO décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}